// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3XJ28"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Usagrafik/usagrafik.scss
 ** module id = 464
 ** module chunks = 0
 **/